import React, { useState ,useEffect} from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import '../Component/Component.css';
import AllUsersTab from './AllUsersTab';
import AllowedUsersTab from './AllowedUsersTab';
import HistoryTab from './HistoryTab';

// CustomTabPanel component to render tab panels
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

// Function to add accessibility props
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

// Main component to display the tabs and their content
export default function BasicTabs({ relay }) {
  const [value, setValue] = useState(0); // State to track the selected tab
  

  // Handle tab change
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' ,padding:"0px"}}>
      <Box sx={{
        borderBottom: 1, borderColor: 'divider',
        '& .MuiTab-root': { color: 'white !important' }, // Unselected tab color
        '& .Mui-selected': { color: 'white !important' }, // Selected tab color
        '& .MuiTabs-indicator': { backgroundColor: 'white' }, // Indicator color
      }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab className='tab-title' label="All Users" {...a11yProps(0)} />
          <Tab className='tab-title' label="Allowed Users" {...a11yProps(1)} />
          <Tab className='tab-title' label="History" {...a11yProps(2)} />
        </Tabs>
      </Box >
      <CustomTabPanel value={value} index={0} padding={0}>
        <AllUsersTab relay={relay} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <AllowedUsersTab relay={relay} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <HistoryTab relay={relay} />
      </CustomTabPanel>
    </Box>
  );
}
